import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faPlus } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Delete from '@frontend/Components/Delete/Delete';
import type { Column } from '@frontend/Models/Table/TableModels';
import type { Agent } from '@frontend/Models/Agent/AgentModels';

/**
 * This creates the agent table columns.
 * @param handleDelete the function to call when an agent is deleted
 * @param onAgentClick the function to call when an agent ID is clicked
 * @returns an array of table columns
 */
export const createAgentsColumns = (
  handleDelete: (agentId: string) => Promise<string | undefined>,
  onAgentClick?: (agentId: string) => void
): Column<Agent>[] => [
  {
    header: 'Agents ID',
    accessor: 'AgentID',
    render: (row: Agent) => (
      <button className="TableLink" onClick={() => onAgentClick?.(row.AgentID)}>
        {row.AgentID}
      </button>
    ),
  },
  {
    header: 'Agents',
    accessor: 'AgentID',
    icon: faUser,
    render: (row: Agent) => `${row.FirstName ?? ''} ${row.LastName ?? ''}`,
  },
  { header: 'Company', accessor: 'Company' },
  { header: 'Email', accessor: 'Email' },
  { header: 'Phone', accessor: 'Phone' },
  { header: 'Address', accessor: 'Address' },
  {
    header: (
      <div className="due-date-header">
        <Link to="/createAgent" className="add-icon-link">
          <FontAwesomeIcon
            icon={faPlus}
            className="icon-button"
            aria-label="Add"
          />
        </Link>
      </div>
    ),
    render: (row: Agent) => (
      <Delete
        onDelete={() => handleDelete(row.AgentID)}
        itemName="agent"
        size="medium"
        onSuccess={() => {}}
      />
    ),
  },
];
